import type { ReactNode } from 'react'
import HeroClouds from './HeroClouds'
import './PageHero.css'

interface Props {
  children: ReactNode
  /** Extra class on the inner container (e.g. for page-specific grid layouts) */
  innerClassName?: string
  /** Render as a <header> instead of the default <section> */
  as?: 'section' | 'header'
}

export default function PageHero({ children, innerClassName, as: Tag = 'section' }: Props) {
  return (
    <Tag className="page-hero">
      <HeroClouds />
      <div className={`container page-hero__inner${innerClassName ? ` ${innerClassName}` : ''}`}>
        {children}
      </div>
    </Tag>
  )
}
